<div class="card flex flex-column border-transparent">
  <div class="goals-card__header">
    <div class="goals-card__title font-bold">{{ 'RELATION.GOALS_CARD.TITLE' | translate }}</div>
    <div class="goals-card__actions">
      <button
        *ngIf="relation?.mr_status === 10"
        pButton
        type="button"
        [label]="goalsNotified ? 'Mentor notified' : ('RELATION.GOALS_CARD.NOTIFY' | translate)"
        [disabled]="!goalsForm.value.goals || goalsNotified"
        (click)="shareGoals()"
        class="text-xs py-1"
        [ngClass]="goalsNotified ? 'p-button-secondary' : 'p-button-success'"
        [pTooltip]="goalsForm.value.goals && !goalsNotified ? ('RELATION.GOALS_CARD.NOTIFY_TOOLTIP' | translate) : null"
        tooltipPosition="bottom"
        data-umami-event="Notify edited goals"
      ></button>
      <button
        pButton
        type="button"
        [routerLink]="'../' + INNERSMARTGOALSGENERATOR"
        [disabled]="!goalsForm.value.goals"
        class="p-button-redirect text-xs p-1 ml-1"
        [pTooltip]="'RELATION.GOALS_CARD.SMART_GOALS_TOOLTIP' | translate"
        tooltipPosition="bottom"
        data-umami-event="Use smart goals generator"
      >
        <fa-icon #icon [icon]="faWand"></fa-icon>
      </button>
    </div>
  </div>
  <ng-container *ngIf="[10, 11, 6].includes(relation?.mr_status)">
    <form [formGroup]="goalsForm" class="relative text-sm m-0 w-full h-full">
      <div #divGoals class="fix-height-list mt-4">
        <p-editor
          #editorGoals
          formControlName="goals"
          [placeholder]="
            relation?.supporter.type === 'mentor'
              ? ('RELATION.GOALS_CARD.PLACEHOLDER_MENTOR' | translate)
              : ('RELATION.GOALS_CARD.PLACEHOLDER_COACH' | translate)
          "
          styleClass="border-none"
          class="p-editor-hide-toolbar"
        >
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button type="button" class="ql-bold" aria-label="Bold"></button>
              <button type="button" class="ql-italic" aria-label="Italic"></button>
              <button type="button" class="ql-underline" aria-label="Underline"></button>
              <button type="button" class="ql-list" value="ordered" aria-label="Ordered list"></button>
              <button type="button" class="ql-list" value="bullet" aria-label="Bullet list"></button>
            </span>
          </ng-template>
        </p-editor>
      </div>
    </form>
  </ng-container>
  <ng-container *ngIf="![10, 11, 6].includes(relation?.mr_status)">
    <div class="fix-height-list">
      <p-editor [(ngModel)]="goalsWhenFinished" styleClass="border-none" class="p-editor-hide-toolbar" [readonly]="true"></p-editor>
    </div>
  </ng-container>
</div>
